import { render, staticRenderFns } from "./monetaryActionRealTypeSelectBox.vue?vue&type=template&id=3668d020&scoped=true&"
import script from "./monetaryActionRealTypeSelectBox.vue?vue&type=script&lang=js&"
export * from "./monetaryActionRealTypeSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668d020",
  null
  
)

export default component.exports